const digest = 'd826374e91d9c9aaf01f2226447da078f9ebf43183331f4ab6d6192b36075219';
const css = `._popup_1gyqf_1{left:0;position:absolute;top:-.625rem;z-index:80}@media (max-width:800px) and (min-width:768px){._popup_1gyqf_1{left:0;max-width:46.9rem;position:absolute;top:-.625rem;z-index:80}}@media (max-width:767px){._popup_1gyqf_1{bottom:0;left:0!important;overflow:auto;position:fixed;right:0;top:0;width:auto;z-index:10400}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'popup': '_popup_1gyqf_1' };
export const popup = '_popup_1gyqf_1';
export { css, digest };